import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAuthModalOpen } from "../../store/features/authModalSlice";
import LogoSignIn from "./LogoSignIn";
import SigninForm from "./SigninForm";
import SignupForm from "./SignupForm";
import ForgotPasswordForm from "./ForgotPasswordForm";

const actionState = {
  signin: "signin",
  signup: "signup",
  forgot: "forgot", // ✅ Add this
};

const AuthModal = () => {
  const { authModalOpen } = useSelector((state) => state.authModal);
  const dispatch = useDispatch();

  const [action, setAction] = useState(actionState.signin);

  useEffect(() => {
    if (authModalOpen) setAction(actionState.signin);
  }, [authModalOpen]);

  const handleClose = () => dispatch(setAuthModalOpen(false));
  const switchAuthState = (state) => setAction(state);

  return (
    <>
      {/* Modal Overlay */}
      {authModalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70  "
          onClick={handleClose}
        >
          {/* Modal Container */}
          <div
            className="relative w-full max-w-lg bg-darkbg rounded-lg shadow-lg p-6 border border-neonYellow m-3 overflow-y-auto scrollbar-thin max-h-[65vh]"
            onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
          >
            {/* Close button (optional) */}
            <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-yellowstar text-xl hover:text-navy hover:bg-yellowstar rounded-full transition w-8 h-8
"
            >
              &times;
            </button>

            {/* Modal Content */}
            <div className="text-center mb-8">
              <LogoSignIn />
            </div>

            {action === actionState.signin && (
              <SigninForm
                switchAuthState={switchAuthState}
                actionState={actionState}
              />
            )}

            {action === actionState.signup && (
              <SignupForm
                switchAuthState={switchAuthState}
                actionState={actionState}
              />
            )}

            {action === actionState.forgot && (
              <ForgotPasswordForm switchAuthState={switchAuthState} />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AuthModal;
